
export const FAVICON__TEN_BY_TEN = 'https://go10x10.com/favicon.ico';
